import { useTheme, Dialog, Slide } from '@mui/material'
import noop from 'lodash/noop'
import PropTypes from 'prop-types'
import React from 'react'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide ref={ref} direction="up" {...props} />
})

const APPBAR_SX = { backgroundColor: '#F7F9FC', borderBottom: '2px solid', borderBottomColor: 'primary.main' }

const HHFullScreenBaseDialog = ({ children, onClose = noop, sx = {}, ...rest }) => {
  const theme = useTheme()
  return (
    <Dialog
      {...rest}
      fullScreen
      sx={{ zIndex: theme.zIndex.snackbar, '& header': { ...APPBAR_SX, zIndex: theme.zIndex.snackbar }, ...sx }}
      TransitionComponent={Transition}
      onClose={onClose}
    >
      {children}
    </Dialog>
  )
}

HHFullScreenBaseDialog.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func,
  sx: PropTypes.object,
}

export default HHFullScreenBaseDialog
